import { FuncResponse, FuncResponseType, FunctionBase, RunStreamResponse } from "./FunctionBase";
import { FunctionUtil } from "./FunctionUtil";
export class InterviewBotFunction extends FunctionBase {
    constructor(brainClient, authStore, meStore) {
        super(brainClient, authStore);
        this.brainClient = brainClient;
        this.authStore = authStore;
        this.meStore = meStore;
        this.url = "/stream/bas-demo-v4/nlp/completions_generation";
        this.domain = "brain_studios";
        this.identifierType = "file";
        this.identifierValue = "agent_node_description_generation_from_previous_node_and_edge.model";
        this.streaming = false;
    }
    async run(input, identityInfo, ...arg) {
        return this.runStream(input, identityInfo);
    }
    async runStream(input, identityInfo) {
        let postParam = {
            domain: "brain_studios",
            identifier_type: "file",
            identifier_value: "agent_node_description_generation_from_previous_node_and_edge.model",
            stream: true,
            variables: {
                instruction: "create an agent that interviews the candidate for the position",
                context: input,
            },
        };
        let url = "/stream/bas-demo-v4/nlp/completions_generation";
        let streamResponse = new RunStreamResponse();
        let received = (msg) => {
            if (msg.done) {
                msg.abort();
            }
            streamResponse.receive(msg.fullText.trim(), msg.done, msg.error);
        };
        return this.postWithStreaming(url, postParam, received, FunctionUtil.createAbortUuid(identityInfo)).then(() => {
            return Promise.resolve(new FuncResponse(FuncResponseType.INTERVIEW_BOT, streamResponse));
        });
    }
    async postWithStreaming(url, params, received, uuid) {
        const result = await this.brainClient.openAi.postWithStreaming(url, params, uuid);
        result.onReceived(result => received(result));
        return Promise.resolve();
    }
}
